<template>
  <div id="app" :class="classes">
    <transition name="fade">
      <WelcomeDisclaimer
        v-if="
          cookies.get('isHcp') === 'false' || cookies.isKey('isHcp') === false
        "
      />
    </transition>
    <transition name="fade">
      <CookieDisclaimer
        v-if="
          cookies.get('acceptCookies') === 'false' ||
          cookies.isKey('acceptCookies') === false
        "
      />
    </transition>

    <LegalDisclaimer />

    <AppHeader
      :showMenuButton="$router.currentRoute.name !== 'welcome'"
      :showTerms="true"
    />

    <router-view class="page" />

    <RelatedContent>
      <template #related-content>
        <ul>
          <li @click="launchTactic(tactics.subtle)">
            <img
              class="thumbnail"
              src="@/assets/img/thumbnail-placeholder.png"
              alt="PDF of an infographic on subtle symptoms and disease progression"
            />
            <img
              src="@/assets/img/icon-pdf-black.svg"
              alt=""
            />
            Insights Into MS: Subtle Symptoms and Disease Progression
          </li>

          <li @click="launchTactic(tactics.cognitiveDecline)">
            <img
              class="thumbnail"
              src="@/assets/img/thumbnail-video-empowering.png"
              alt="Image of a woman sitting with her laptop open in front of her and with her hands covering her face."
            />
            <img
              src="@/assets/img/icon-video-black.svg"
              alt=""
            />
            Cognitive Decline in MS Progression
          </li>

          <li @click="launchTactic(tactics.neuro)">
            <img
              class="thumbnail"
              src="@/assets/img/thumbnail-video-neuroinflammation.png"
              alt="An animation still showing a visual of firing neurons."
            />
            <img
              src="@/assets/img/icon-video-black.svg"
              alt=""
            />
            From Neuroinflammation to Neurodegeneration in MS (6:51)
          </li>
        </ul>
      </template>
    </RelatedContent>

    <AppFooter
      :showTerms="true"
      :showReferences="true"
      jobCode="388555-2"
    ></AppFooter>

    <span
      style="
        font-style: italic;
        visibility: hidden;
        position: absolute;
        pointer-events: none;
      "
      aria-hidden="true"
      >Novartis</span
    >
  </div>
</template>

<script>
// import Preloader from '@/components/Preloader'
import AppFooter from "@/components/AppFooter";
import AppHeader from "@/components/AppHeader";
import LegalDisclaimer from "@/components/LegalDisclaimer";
import WelcomeDisclaimer from "@/components/WelcomeDisclaimer";
import CookieDisclaimer from "@/components/CookieDisclaimer";
import RelatedContent from "@/components/RelatedContent.vue";

export default {
  name: "App",
  components: {
    // Preloader,
    AppFooter,
    AppHeader,
    CookieDisclaimer,
    LegalDisclaimer,
    WelcomeDisclaimer,
    RelatedContent,
  },
  provide() {
    return {
      goToOverview: this.goToOverview,
      gotoRoute: this.gotoRoute,
    };
  },
  data() {
    return {
      scrollTop: 0,
      state: this.$store.state,
      cookies: this.$cookies,
      width: window.innerWidth,
      classes: "",

      tactics: {
        subtle: {
          title: "Subtle Symptoms and Disease Progression",
          urlDev: "/#/diagnosis/subtle-symptoms-and-disease-progression/pdf",
          // urlDev:"https://nov-20364-dev-cac-inv.azurewebsites.net/#/subtle-symptoms-and-disease-progression",
          urlProd: "/diagnosis/subtle-symptoms-and-disease-progression/pdf",
          analyticsLabel:
            "MS Disease Progression Visualizer: Subtle Symptoms and Disease Progression",
        },
        cognitiveDecline: {
          title: "Cognitive Decline in MS Progression",
          urlDev: "/progression/cognitive-functioning/video",
          urlProd: "/progression/cognitive-functioning/video",
          analyticsLabel:
            "MS Disease Progression Visualizer: Cognitive Decline in MS Progression",
        },
        neuro: {
          title:
            "Insights Into MS: From Neuroinflammation to Neurodegeneration in MS",
          urlDev:
            "/#/mechanism-of-disease/neuroinflammation-neurodegeneration/video",
          // urlDev: "https://nov-20364-dev-cac-inv.azurewebsites.net/#/ms-video",
          urlProd:
            "/mechanism-of-disease/neuroinflammation-neurodegeneration/video",
          analyticsLabel:
            "MS Disease Progression Visualizer: From Neuroinflammation to Neurodegeneration in MS",
        },
      },
    };
  },
  computed: {
    isPortrait: function () {
      return this.width < 1024;
    },
    showTopButton() {
      return this.scrollTop > 0;
    },
  },
  watch: {
    "state.showModal": function (newVal) {
      if (newVal !== "") {
        document.body.classList.add("no-scroll");
        // this.$analytics.logEvent("modal", {
        //   value: newVal,
        // });
      } else {
        document.body.classList.remove("no-scroll");
      }
    },
  },
  methods: {
    updateScrollTop() {
      this.scrollTop = document.documentElement.scrollTop;
    },
    scrollHandler() {
      this.updateScrollTop();
    },
    setWidth: function () {
      this.width = this.$el.clientWidth;
      // console.log("resizing! width: ",this.width)

      if (this.width >= 1024) {
        this.$cookies.set("acceptWarning", "true");
      }

      // code to determine if detailed info is showing based on browser size
      if (this.width < 768) {
        this.$store.state.showDetailedInfo = false;
      } else {
        this.$store.state.showDetailedInfo = true;
      }
    },

    launchTactic: function (tactic) {
      this.$gtag.event("click", {
        event_category: "launch_page",
        event_label: tactic.analyticsLabel,
      });

      let url =
        process.env.NODE_ENV === "development" ? tactic.urlDev : tactic.urlProd;

      if (tactic.route) {
        this.$router.push({ name: tactic.route });
      } else {
        window.open(url, "_self");
      }
    },
    goToOverview: function () {
      // Set questions after topic has been selected!

      // QuizPlugin.setQuestions();
      // switch (this.$store.state.currentTopic) {
      //   case "topic1":
      //     this.$router.push({ name: "early-diagnosis" });
      //     break;
      //   case "topic2":
      //     this.$router.push({ name: "early-intervention" });
      //     break;
      //   case "topic3":
      //     this.$router.push({ name: "high-efficacy-treatment" });
      //     break;
      //   case "topic4":
      //     this.$router.push({ name: "biomarkers" });
      //     break;
      //   case "topic5":
      //     this.$router.push({ name: "referral-timing-and-pathways" });
      //     break;
      //   case "topic6":
      //     this.$router.push({ name: "holistic-patient-care" });
      //     break;
      //   case "topic7":
      //     this.$router.push({ name: "covid-19" });
      //     break;
      //   case "topic8":
      //     this.$router.push({ name: "immunoglobulins" });
      //     break;
      //   default:
      //     this.$router.push({ name: "home" });
      // }

      this.$gtag.event("click", {
        event_category: "go_to_overview",
        event_label: "continue",
      });
    },
  },
  created() {
    // adding extra classes to app to detect browsers for video bg color fixing
    let browser = "";

    // Chrome and Safari match default, need overrides for Firefox, Edge, and IE11
    if (this.$browserDetect.isChrome) {
      browser = "chrome";
      if (navigator.platform.toLowerCase() == "win32") {
        browser += "-pc";
      }
    } else if (this.$browserDetect.isSafari) {
      browser = "safari";
    } else if (this.$browserDetect.isFirefox) {
      browser = "firefox";
    } else if (this.$browserDetect.isEdge) {
      browser = "edge";
    } else if (this.$browserDetect.isIE) {
      browser = "ie";
    } else if (
      /iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
    ) {
      // #88: this.$browserDetect.isIOS isn't evaluating correctly so had to use different condition. Known issue on vue-browser-detect-plugin atm. This should be swapped out when the issue is fixed and we can use this.$browserDetect.isIOS properly. See comments here: https://github.com/ICJIA/vue-browser-detect-plugin/issues/11
      browser = "ios";
    }

    this.$store.state.browser = browser;
    this.classes = browser;
    document.body.classList.add(browser);
  },
  mounted() {
    let body = document.body;

    // Reset scroll position on first launch
    body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    window.addEventListener("resize", this.setWidth);

    window.addEventListener("scroll", this.scrollHandler);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setWidth);
    window.removeEventListener("scroll", this.scrollHandler);
  },
};
</script>

<style lang="scss">
@import "@/scss/styles";

body {
  background: $blue-dark-bg;
  position: relative;
  display: flex;
  flex-direction: column;

  &.chrome-pc {
    background: $blue-dark-bg-pc;
  }

  &.firefox {
    background: $blue-dark-firefox;
  }
  &.edge {
    background: $blue-dark-edge;
  }
  &.ie {
    background: $blue-dark-ie;
  }
  &.ios {
    background: $blue-dark-ios;
  }

  * {
    color: #ffffff;
  }

  footer * {
    color: #000000;
  }
  &.no-scroll {
    overflow: hidden;
  }
}

@media (max-width: 1024px) {
  body {
    flex-direction: row;
  }
}

#app {
  // font-family: Helvetica, Arial, sans-serif;
  font-family: "Volta Modern Text Web", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $black;
  font-size: rem(16px);
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;

  &.no-scroll {
    overflow: hidden;
  }

  // Issue #99: Set height on iPad to reduce scroll
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 1) {
    min-height: calc(100vh - 32px); // 100vh - top url bar
  }
}

body {
  &.no-scroll {
    overflow: hidden;
  }
}

.page {
  flex: 1 0 auto;
}

.inner-wrapper {
  width: 100%;
  // min-width: 1024px;
  display: flex;
  flex-basis: auto;
  justify-content: center;
}

.inner-content {
  // height: 100%;
  width: 100%;
  max-width: 1024px;
  // max-height: 768px;
  text-align: left;
  padding: rem(20px) rem(25px);
  @include breakpoint(lg) {
    max-width: 1440px;
  }
  @include breakpoint(xs) {
    overflow: hidden;
  }
}

.row {
  display: block;

  .col-100 {
    display: block;
    width: 100%;
  }

  .col-50 {
    display: inline-block;
    width: 50%;
    vertical-align: top;
  }

  .col-25 {
    width: 25%;
    display: inline-block;
    vertical-align: top;
  }

  .col-30 {
    width: 30%;
    display: inline-block;
    vertical-align: top;
  }

  .col-70 {
    width: 70%;
    display: inline-block;
    vertical-align: top;
  }

  .col-75 {
    width: 75%;
    display: inline-block;
    vertical-align: top;
  }
}

.flex-container {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.bottom-border {
  padding-bottom: rem(20px);
  position: relative;

  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    height: 3px;
    width: 90px;
    background: $white;
  }
}

.btn {
  border: 2px solid $white;
  color: $white;
  background: none;
  padding: rem(14px) rem(20px);
  display: inline-block;
  text-decoration: none;

  &:after {
    content: url("assets/img/icon-chevron.svg");
    width: rem(12px);
    height: rem(20px);
    display: inline-block;
    vertical-align: middle;
    margin-left: rem(10px);
  }

  &.back {
    padding: 0;
    border: none;
    img.arrow {
      vertical-align: middle;
      width: 24px;
      height: 29px;
      transform: rotate(-90deg);
      margin-right: 16px;
    }
    &:after {
      display: none;
    }
  }
}

.btn-cta {
  border: 2px solid $white;
  color: $white;
  background: none;
  padding: rem(20px);
  width: rem(350px);
  display: block;
}

.btn-back {
  border: 1px solid $blue-dark;
  color: $blue-dark;
  background: none;
  padding: rem(20px);
  display: block;
}

// button focus states
button,
a,
video,
video::-webkit-media-controls-timeline,
video::-webkit-media-controls-panel,
video::-webkit-media-controls-play-button,
video::-webkit-media-controls-fullscreen-button {
  &:focus {
    outline: 4px solid#FFD086;
  }
}

button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
  outline: 4px solid#FFD086;
}

video:-moz-focusring {
  outline: 4px solid#FFD086;
  outline: none;
}

a:-moz-focusring {
  outline: 4px solid#FFD086;
}

// Transitions
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.app-header {
  a {
    color: black;
  }
  a:visited {
    color: black;
  }
}

footer {
  color: black;
}
</style>
